import React from 'react';

export default function SVGWalletApp(): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="center" width="80" height="80" fill="none">
      <style>
        {
          '@keyframes a0_o{0%{opacity:1;animation-timing-function:cubic-bezier(.42,0,.58,1)}40.9091%{opacity:.5}50%{opacity:.5;animation-timing-function:cubic-bezier(.42,0,.58,1)}90.9091%{opacity:1}}'
        }
      </style>
      <rect width="80" height="80" fill="#2F0D30" rx="35.438" style={{ animation: '2.2s linear infinite both a0_o' }} />
      <path
        fill="#FF6B4E"
        d="M45.998 34.954a5.471 5.471 0 1 0-10.943 0 5.467 5.467 0 0 0 2.957 4.856l-2.028 8.768h9.084l-2.027-8.768a5.467 5.467 0 0 0 2.957-4.856Z"
        style={{ animation: '2.2s linear infinite both a0_o' }}
      />
      <path
        fill="#FF6B4E"
        d="M63.795 47.714c-1.178 9.147-9.01 16.24-18.473 16.24H34.815c-10.273 0-18.632-8.358-18.632-18.632V34.816c0-10.274 8.358-18.633 18.632-18.633h10.507c9.463 0 17.295 7.093 18.473 16.24h6.225C68.812 19.859 58.198 10 45.322 10H34.815C21.132 10 10 21.132 10 34.816v10.506c0 13.683 11.132 24.815 24.815 24.815h10.507c12.876 0 23.49-9.858 24.698-22.423h-6.225Z"
        style={{ animation: '2.2s linear infinite both a0_o' }}
      />
    </svg>
  );
}
